import { PaymentStateTypes } from '../../interfaces';

export const state: PaymentStateTypes = {
    paymentList: {},
    paymentDetail: undefined,
    paymentSummary: undefined,
    paymentDetails: [],
};
